import { Command } from '../command.model';

export class NavigateByPathCommand implements Command {}
